import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useFirestore } from 'react-redux-firebase';
import { dateToStringWithHour } from '../../utils/DateUtil';
import Functions from '../../api/Functions';
import Loading from '../generalComponets/Loading';
import { messageCounterTemplatesRef, messageTemplatesRef } from '../../api/fbCollections';

function MessageStatistic() {
  let { id } = useParams();
  const [showProcess, setShowProcess] = useState(false);
  const [messageTemplate, setMessageTemplate] = useState(null);
  const [messageCounterTemplate, setMessageCounterTemplate] = useState(null);
  const firestore = useFirestore();
  
  useEffect(() => {
    getMessageTemplate(firestore, id);
    getMessageCounterTemplate(firestore, id);
  }, [firestore, id]);

  const getMessageTemplate = (firestore, id) => {
    firestore
      .collection(messageTemplatesRef)
      .doc(id)
      .get()
      .then((doc) => {
        if (doc.exists) {
          setMessageTemplate({ id: doc.id, ...doc.data() });
        }
      });
  };
  
  const getMessageCounterTemplate = (firestore, id) => {
    firestore
      .collection(messageCounterTemplatesRef)
      .doc(id)
      .get()
      .then((doc) => {
        if (doc.exists) {
          setMessageCounterTemplate({ id: doc.id, ...doc.data() });
        }
      });
  };

  const calculateCounters = () => {
    setShowProcess(true);
    Functions.calculateCountersOfMessageTemplates(messageTemplate.id)
      .then(() => {
        getMessageTemplate();
        getMessageCounterTemplate();
        setShowProcess(false);
      })
      .catch((e) => {
        console.log(e.message());
        setShowProcess(true);
      });
  };

  function openTab(link) {
    window.open(link);
  }

  const renderMessageTemplate = () => {
    return (
      <div>
        <h4>Message detail</h4>
        <p>Id: {messageTemplate.id}</p>
        <p>Title: {messageTemplate.title}</p>
        <p>Message: {messageTemplate.message}</p>
        {messageTemplate.country ? <p>Country: {messageTemplate.country}</p> : <div />}
        <p>Scope: {messageTemplate.scope}</p>
        <p>With PushNotification: {messageTemplate.pushNotification ? 'Yes' : 'No'}</p>
        {messageTemplate.link ? (
          <p className="blue-text" onClick={() => openTab(messageTemplate.link)}>
            Link
          </p>
        ) : (
          <div />
        )}
        {messageTemplate.imageUrl && messageTemplate.imageUrl.length > 0 ? (
          <img className="reward-image" src={messageTemplate.imageUrl} alt={'imageUrl'} />
        ) : (
          <div />
        )}
      </div>
    );
  };

  const renderMessageCounterTemplate = () => {
    return (
      <div>
        <h4>Counters</h4>
        <h6>UpdatedAt: {dateToStringWithHour(messageTemplate.updatedAt.toDate())}</h6>
        <button className="btn" onClick={calculateCounters}>
          Calculate
        </button>
        {messageTemplate.link ? <p>Link: {messageTemplate.counters.link}</p> : <div />}
        {messageTemplate.link ? <p>Link First: {messageTemplate.counters.linkFirst}</p> : <div />}
        <p>Open: {messageTemplate.counters.open}</p>
        <p>OpenFirst: {messageTemplate.counters.openFirst}</p>
        <p>Sent: {messageTemplate.counters.sent}</p>
      </div>
    );
  };

  return (
    <div className="container">
      <div className="title-section">Message Template</div>
      {showProcess ? <Loading /> : <div />}
      <div className="row">
        <div className="col s6">{messageTemplate ? renderMessageTemplate() : <div />}</div>
        <div className="col s6">{messageCounterTemplate ? renderMessageCounterTemplate() : <div />}</div>
      </div>
    </div>
  );
}

export default MessageStatistic;
